import React from "react";

import Iconify from "components/iconify";
import "./style.css";

const PopularFlight = ({
  inbound,
  outbound,
  originCode,
  destinationCode,
  source,
  onClick,
}) => {
  return (
    <div
      className="popular-flight-card"
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onClick?.();
        }
      }}
    >
      <img
        className="popular-flight-card__image"
        src={source}
        alt={`${inbound} (${originCode || ""}) - ${outbound} (${destinationCode || ""})`}
        loading="lazy"
      />
      <div className="popular-flight-card__overlay" />
      <div className="popular-flight-card__content">
        <div className="popular-flight-card__route">
          <span>{inbound}</span>
          <span className="popular-flight-card__plane">
            <Iconify icon="mdi:airplane" width={16} />
          </span>
          <span>{outbound}</span>
        </div>
      </div>
      <div className="popular-flight-card__cta">
        <Iconify icon="mdi:arrow-right" width={20} />
      </div>
    </div>
  );
};

export default PopularFlight;
